'use client'
import React, { useEffect, useState } from 'react'
import { SearchIcon } from '@/shared/Icons'
import SearchModalBox from '@/shared/components/search'
import DarkModeButton from '../../darkModeButton'

export default function SearchModal() {
  const [isOpen, setIsOpen] = useState(false)
  function onClose() {
    setIsOpen(false)
  }
  useEffect(() => {
    function searchShortcut(e: any) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'f') {
        e.preventDefault()
        setIsOpen(true)
      } else if (isOpen && e.key === 'Escape') {
        e.preventDefault()
        onClose()
      }
    }
    window.addEventListener('keydown', searchShortcut)
    return () => window.removeEventListener('keydown', searchShortcut)
  }, [isOpen])
  return (
    <>
      <div className='flex items-center gap-2 ml-auto'>
        <DarkModeButton />
        <div className='cursor-pointer dark:brightness-0 invert-[1]  ' onClick={() => setIsOpen(true)}>
          <SearchIcon />
        </div>
      </div>
      {isOpen && <SearchModalBox isOpen={isOpen} onClose={onClose} />}
    </>
  )
}
